import React, { CSSProperties } from 'react';
import styled from 'styled-components';
import {Card,ListItem} from './../elements'
import { CONSTS } from './_constants';
type ListCardComponentProps = {
    className?: string,
    style?:CSSProperties,
    title?: string,
    back?: boolean,
    headerMeta?: any,
    children?: any,
    goBack?: Function,
    renderItem?: Function,
    items?: any[]
}
const ListCardComponent = (props: ListCardComponentProps) => {
    return (
        <Card title={props.title} className={props.className}>  
            <div className="_items">
                {props.items && props.renderItem &&
                    props.items.map(
                        (v,k)=>props.renderItem && props.renderItem(v,k)
                    )
                }
            </div>
        </Card>
    )
}

const ListCard = styled(ListCardComponent)`
._items {
    width: 100%;
    ._list-item {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        &:last-child {
            border-bottom: none;
        }
        ._icon {
            font-size: 16px;
            width: 55px;
            display: flex;
            justify-content: center;
            flex-direction: column;
            align-items: center;
            height: auto;
            color: ${CONSTS.colors.greyDark};
            border-right: 1px solid rgba(63,63,68,.07);
            transition: all .2s ease;
        }
        &:hover {
            ._icon {
                color: ${CONSTS.colors.primary};
            }
        }
    }
}
    
`
export default ListCard;